export default class Store {
  constructor($ngRedux) {
    'ngInject';
    Object.assign(this, $ngRedux);
  }
}
